<template lang='pug'>
div(:class='datePickerClass' v-if='show' :style='topRightStyle' id="date-picker")
  DatePickerHead(v-if='header' :startDate='select1'  :endDate='select2')
  Calendar(:startDate='startDate' @select='select' @newselect='newselect' :date1='select1' :date2='select2')
  DatePickerButton(@submit='filter' @cancel='cancel' ref='button')
</template>
<script>
import DatePickerHead from '@/components/modules/date_picker/date_picker_head.vue'
import Calendar from '@/components/modules/date_picker/date_picker_calendar.vue'
import DatePickerButton from '@/components/modules/date_picker/date_picker_button.vue'
import { newDateObject, deviceType } from '@/plugins/tool.js'
import $ from 'jquery'

export default {
  props: {
    popup: Boolean,
    startDate: String,
    header: Boolean,
    width: String,
    top: String,
    date1: String,
    date2: String
  },
  components: {
    DatePickerHead,
    Calendar,
    DatePickerButton
  },
  data() {
    return {
      show: false,
      start: this.startDate,
      select1: "",
      select2: "",
      preStart: "",
      preEnd: ""
    }
  },
  created() {
    if (this.date1 && this.date2) {
      this.select1 = this.date1
      this.select2 = this.date2
    }
  },
  mounted() {
    $(document).click((e) => {
      if (deviceType() == 'tablet' || deviceType() == 'mobile') return
      let datePicker = document.getElementById("date-picker")
      let filter1 = document.getElementById("date-picker-dropdownFilter")
      let filter2 = document.getElementById("date-picker-dropdownFilter2")
      if (datePicker && filter1) {
        if (!$.contains(datePicker, e.target) && !$.contains(filter1, e.target) && filter1 != e.target) {
          if (filter2) {
            if (!$.contains(filter2, e.target) && filter2 != e.target)
              this.cancel()
          }
          else
            this.cancel()
        }
      }
    });
  },
  computed: {
    datePickerClass() {
      if (this.popup) {
        return 'popup-body popup-body--calendar'
      }
      return 'title-datepicker'
    },
    topRightStyle() {
      var style = ''
      if (this.top)
        style += 'top: ' + this.top + ';'
      if (this.width)
        style += 'width: ' + this.width + ';'
      if (!this.header)
        style += 'height: 467px'
      return style
    }
  },
  methods: {
    focus() {
      this.show = !this.show
    },
    newselect() {
      this.$refs.button.inactive()
    },
    select(start, end) {
      if (!this.preStart && !this.preEnd) {
        this.preStart = this.select1
        this.preEnd = this.select2
      }
      this.select1 = start
      this.select2 = end
      this.$refs.button.active()
      this.$emit('select', newDateObject(this.select1), newDateObject(this.select2))
    },
    filter() {
      if (!this.select1 || !this.select2) {
        return
      }
      this.preStart = ""
      this.preEnd = ""
      this.deletePreviousOption()
      const startDate = newDateObject(this.select1)
      startDate.setHours(0);startDate.setMinutes(0);startDate.setSeconds(0)
      const endDate = newDateObject(this.select2)
      endDate.setHours(23);endDate.setMinutes(59);endDate.setSeconds(59)
      this.$emit('filter', startDate, endDate)
      this.focus()
    },
    cancel() {
      this.select1 = this.preStart
      this.select2 = this.preEnd
      if (this.select1 && this.select2) {
        this.$emit('cancel', newDateObject(this.select1), newDateObject(this.select2))
      } else {
        this.$emit('cancel', null, null)
      }
      this.show = false
    },
    deletePreviousOption() {
      this.preStart = ""
      this.preEnd = ""
    }
  }
}
</script>
